import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { FadeIn } from "../components/FadeIn";
import { Overline, PullQuote } from "../components/Primitives";
import { ARTICLES } from "../data/articles";

export default function Article() {
  const { slug } = useParams();
  const article = ARTICLES[slug];

  if (!article) {
    return (
      <div className="max-w-[1200px] mx-auto px-6 py-32 text-center" data-testid="article-not-found">
        <h1 className="font-playfair text-3xl text-amf-navy">Article not found</h1>
        <Link to="/publications" className="amf-overline text-amf-burgundy mt-6 inline-block">
          Back to Publications
        </Link>
      </div>
    );
  }

  return (
    <article data-testid="article-page">
      {/* Header */}
      <section className="relative bg-amf-navy">
        <img
          src={article.image}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover opacity-25 amf-img"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-amf-navy/70 to-amf-navy" />
        <div className="relative max-w-3xl mx-auto px-6 md:px-10 py-20 md:py-28">
          <FadeIn>
            <Link
              to="/publications"
              className="amf-overline text-amf-gold inline-flex items-center gap-2 mb-7 hover:gap-3 transition-all"
            >
              <ArrowLeft size={15} /> Publications
            </Link>
            <h1 className="font-playfair text-3xl md:text-4xl lg:text-5xl leading-tight text-amf-cream">
              {article.title}
            </h1>
            {article.strapline && (
              <p className="font-playfair italic text-xl text-amf-gold mt-5">
                “{article.strapline}”
              </p>
            )}
            <p className="amf-overline text-amf-cream/70 mt-6">
              {article.author} · {article.date}
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Body */}
      <div className="bg-amf-cream py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <FadeIn>
            <img
              src={article.image}
              alt={article.title}
              className="w-full aspect-[16/9] object-cover amf-img mb-12"
            />
          </FadeIn>
          <div className="prose-amf">
            {article.body.map((block, i) => {
              if (block.type === "h2")
                return (
                  <FadeIn as="h2" key={i}>
                    {block.text}
                  </FadeIn>
                );
              return (
                <FadeIn as="p" key={i}>
                  {block.text}
                </FadeIn>
              );
            })}
          </div>

          {article.pullQuote && <PullQuote>{article.pullQuote}</PullQuote>}

          <div className="mt-12 pt-8 border-t border-amf-gold/30">
            <Link
              to="/publications"
              className="amf-overline text-amf-burgundy inline-flex items-center gap-2 hover:gap-3 transition-all"
            >
              <ArrowLeft size={15} /> Back to Publications
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
}
